var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-input',{attrs:{"label":_vm.label,"placeholder":"0.00","right":"","value":_vm.value,"left-add-on":"$","error":_vm.error},on:{"input":_vm.update,"blur":_vm.blur}})}
var staticRenderFns = []

export { render, staticRenderFns }